import { ComponentProps, useState } from "react";

import { cn } from "~/lib/utils";

function _DebugBreakpoints() {
    const [showGrid, setShowGrid] = useState(false);
    return (
        <div>
            <button
                className="bg-black bg-opacity-80 rounded-md fixed bottom-0 left-0 m-4 p-2 text-white font-mono text-xs max-w-[5ch] text-center w-full hover:ring transition-all hover:ring-black/20"
                onClick={() => setShowGrid((prev) => !prev)}
            >
                <div className="block sm:hidden md:hidden lg:hidden xl:hidden 2xl:hidden">&empty;</div>
                <div className="hidden sm:block md:hidden lg:hidden xl:hidden 2xl:hidden">sm</div>
                <div className="hidden sm:hidden md:block lg:hidden xl:hidden 2xl:hidden">md</div>
                <div className="hidden sm:hidden md:hidden lg:block xl:hidden 2xl:hidden">lg</div>
                <div className="hidden sm:hidden md:hidden lg:hidden xl:block 2xl:hidden">xl</div>
                <div className="hidden sm:hidden md:hidden lg:hidden xl:hidden 2xl:block">2xl</div>
            </button>
            <div className={cn("pointer-events-none transition-opacity", showGrid ? "opacity-100" : "opacity-0")}>
                <Breakpoint className="before:content-['sm']" style={{ left: `640px` }} />
                <Breakpoint className="before:content-['md']" style={{ left: `768px` }} />
                <Breakpoint className="before:content-['lg']" style={{ left: `1024px` }} />
                <Breakpoint className="before:content-['xl']" style={{ left: `1280px` }} />
                <Breakpoint className="before:content-['2xl']" style={{ left: `1536px` }} />
            </div>
        </div>
    );
}

function Breakpoint({ className, ...props }: ComponentProps<"div">) {
    return (
        <div
            className={cn(
                "fixed top-0 bottom-0 w-[1px] border border-destructive z-50 before:text-black",
                "before:absolute before:top-0 before:font-mono before:py-1 before:px-2 before:bg-destructive before:bg-opacity-40 before:rounded-md before:m-1 before:text-sm before:right-full",
                className
            )}
            {...props}
        />
    );
}

export const DebugBreakpoints = process.env.NODE_ENV !== "production" ? _DebugBreakpoints : () => null;
